import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import Preise from "@/pages/Preise";
import Anfrage from "@/pages/Anfrage";
import AnfrageChooser from "@/pages/AnfrageChooser";
import PrivatKoch from "@/pages/PrivatKoch";
import AnfragePrivat from "@/pages/AnfragePrivat";
import UeberMich from "@/pages/UeberMich";
import Kontakt from "@/pages/Kontakt";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import Admin from "@/pages/Admin";
import StundenBestaetigen from "@/pages/StundenBestaetigen";
import StundennachweisBestaetigen from "@/pages/StundennachweisBestaetigen";
import EinsatzplanBestaetigen from "@/pages/EinsatzplanBestaetigen";
import EventSeite from "@/pages/EventSeite";
import AngebotSeite from "@/pages/AngebotSeite";
import RechnungSeite from "@/pages/RechnungSeite";
import SammelrechnungSeite from "@/pages/SammelrechnungSeite";
import StartVorschau from "@/pages/vorschau/StartVorschau";
import KontaktVorschau from "@/pages/vorschau/KontaktVorschau";
import StartWow from "@/pages/vorschau/StartWow";
import MitarbeiterZeiten from "@/pages/MitarbeiterZeiten";
import AuftragBestaetigen from "@/pages/AuftragBestaetigen";
import Bewertung from "@/pages/Bewertung";
import NewsletterBestaetigen from "@/pages/NewsletterBestaetigen";
import NewsletterAbmelden from "@/pages/NewsletterAbmelden";
import AnfrageAnnehmen from "@/pages/AnfrageAnnehmen";
import AngebotAnnehmen from "@/pages/AngebotAnnehmen";
import StundenAngebot from "@/pages/StundenAngebot";
import ZeitBestaetigen from "@/pages/ZeitBestaetigen";
import Gutscheine from "@/pages/Gutscheine";
import GutscheinKaufen from "@/pages/GutscheinKaufen";
import GutscheinDanke from "@/pages/GutscheinDanke";
import GutscheinEinloesen from "@/pages/GutscheinEinloesen";
import { AnalyticsTracker } from "@/components/AnalyticsTracker";
import Vermittlung from "@/pages/Vermittlung";
import VermittlungKoch from "@/pages/VermittlungKoch";
import VermittlungBetrieb from "@/pages/VermittlungBetrieb";
import VermittlungPrivat from "@/pages/VermittlungPrivat";
import VertragUnterschreiben from "@/pages/VertragUnterschreiben";
import KochPortal from "@/pages/KochPortal";
import NotFound from "@/pages/NotFound";
import MietkochWerden from "@/pages/MietkochWerden";
import MenuekarteDownload from "@/pages/MenuekarteDownload";
import ReelSeite from "@/pages/ReelSeite";

function App() {
  return (
    <div className="App min-h-screen bg-[#FAFAF7] text-[#2C2A26]">
      <BrowserRouter>
        <AnalyticsTracker />
        <Layout>
          <Routes>
            <Route path="/" element={<StartWow />} />
            <Route path="/start-alt" element={<Home />} />
            <Route path="/leistungen" element={<Leistungen />} />
            <Route path="/preise" element={<Preise />} />
            <Route path="/anfrage" element={<AnfrageChooser />} />
            <Route path="/vermittlung" element={<Vermittlung />} />
            <Route path="/mietkoch-werden" element={<MietkochWerden />} />
            <Route path="/vermittlung/koch-registrieren" element={<VermittlungKoch />} />
            <Route path="/vermittlung/koch-anfordern" element={<VermittlungBetrieb />} />
            <Route path="/vermittlung/privatkoch-anfragen" element={<VermittlungPrivat />} />
            <Route path="/vermittlung/vertrag/:id" element={<VertragUnterschreiben />} />
            <Route path="/koch/:id" element={<KochPortal />} />
            <Route path="/anfrage-betrieb" element={<Anfrage />} />
            <Route path="/privatkoch" element={<PrivatKoch />} />
            <Route path="/anfrage-privat" element={<AnfragePrivat />} />
            <Route path="/ueber-mich" element={<UeberMich />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
            <Route path="/agb" element={<AGB />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/menuekarte-dm" element={<MenuekarteDownload />} />
            <Route path="/reel" element={<ReelSeite />} />
            <Route path="/stunden-bestaetigen/:token" element={<StundenBestaetigen />} />
            <Route path="/stundennachweis/:token" element={<StundennachweisBestaetigen />} />
            <Route path="/einsatzplan/:token" element={<EinsatzplanBestaetigen />} />
            <Route path="/abend/:slug" element={<EventSeite />} />
            <Route path="/angebot-fuer/:slug" element={<AngebotSeite />} />
            <Route path="/rechnung-fuer/:slug" element={<RechnungSeite />} />
            <Route path="/rechnung/:token" element={<SammelrechnungSeite />} />
            <Route path="/vorschau/start" element={<StartVorschau />} />
            <Route path="/vorschau/kontakt" element={<KontaktVorschau />} />
            <Route path="/vorschau/start-wow" element={<StartWow />} />
            <Route path="/mitarbeiter/:token" element={<MitarbeiterZeiten />} />
            <Route path="/auftrag-bestaetigen/:token" element={<AuftragBestaetigen />} />
            <Route path="/bewertung/:token" element={<Bewertung />} />
            <Route path="/newsletter-bestaetigen/:token" element={<NewsletterBestaetigen />} />
            <Route path="/newsletter-abmelden/:token" element={<NewsletterAbmelden />} />
            <Route path="/anfrage-annehmen/:id" element={<AnfrageAnnehmen />} />
            <Route path="/angebot/:token" element={<AngebotAnnehmen />} />
            <Route path="/stunden-angebot/:token" element={<StundenAngebot />} />
            <Route path="/zeit-bestaetigen/:token" element={<ZeitBestaetigen />} />
            <Route path="/gutscheine" element={<Gutscheine />} />
            <Route path="/gutscheine/bestellen/:productType" element={<GutscheinKaufen />} />
            <Route path="/gutscheine/danke/:orderNumber" element={<GutscheinDanke />} />
            <Route path="/einloesen" element={<GutscheinEinloesen />} />
            <Route path="/einloesen/:nummer" element={<GutscheinEinloesen />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
